import { WorkStates } from './work-states-enum'
import { DeviceTypes } from './device-types-enum'

/**
 * Enumeration for work state devices.
 *
 * @readonly
 * @enum {string}
 */
export const WorkStateDevices = {
    [WorkStates.FREETIME]: DeviceTypes.PND,
    [WorkStates.WORKING]: DeviceTypes.PND,
    [WorkStates.AVAILABLE]: DeviceTypes.TACHOGRAPH,
    [WorkStates.OTHER_WORK]: DeviceTypes.TACHOGRAPH,
    [WorkStates.DRIVING]: DeviceTypes.TACHOGRAPH
}

Object.freeze(WorkStateDevices)
